import { memo } from "react";
import {
  Stack,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  Divider,
} from "@mui/material";
import { ExtractedAnalyte } from "../../../hooks/types";
import { scrollbarStyle } from "../../../../scrollbarStyle";

interface AnalytesListProps {
  analytes: ExtractedAnalyte[];
  onSelectAnalyte: (index: number) => void;
  onSelectAll: (checked: boolean) => void;
}

export const AnalytesList = memo(
  ({ analytes, onSelectAnalyte, onSelectAll }: AnalytesListProps) => {
    const allSelected = analytes.every((a) => a.selected);
    const someSelected = analytes.some((a) => a.selected);

    return (
      <Stack spacing={1} sx={{ flex: 1, minHeight: "200px" }}>
        <Typography variant="h6" sx={{ mb: 0.5 }}>
          Analitos Extraídos
        </Typography>

        <FormControlLabel
          control={
            <Checkbox
              size="small"
              onChange={(e) => onSelectAll(e.target.checked)}
              checked={allSelected}
              indeterminate={someSelected && !allSelected}
            />
          }
          label="Selecionar todos"
        />

        <Box
          sx={{
            flex: 1,
            minHeight: "150px",
            overflow: "auto",
            ...scrollbarStyle,
          }}
        >
          <Stack divider={<Divider />}>
            {analytes.map((analyte, index) => (
              <Box
                key={index}
                sx={{
                  py: 1,
                  px: 1,
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  bgcolor: analyte.selected ? "action.selected" : "transparent",
                  "&:hover": {
                    bgcolor: analyte.selected
                      ? "action.selected"
                      : "action.hover",
                  },
                }}
                onClick={() => onSelectAnalyte(index)}
              >
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Checkbox
                    size="small"
                    checked={analyte.selected}
                    onChange={() => onSelectAnalyte(index)}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <Typography
                    sx={{
                      flex: 1,
                      fontWeight: analyte.selected ? 600 : 400,
                      color: analyte.selected ? "primary.main" : "text.primary",
                    }}
                  >
                    {analyte.name}
                  </Typography>
                  <Typography
                    sx={{
                      minWidth: "100px",
                      textAlign: "right",
                      color: "text.secondary",
                    }}
                  >
                    {analyte.value} {analyte.unit}
                  </Typography>
                  <Typography
                    sx={{
                      minWidth: "100px",
                      textAlign: "right",
                      color: "text.secondary",
                    }}
                  >
                    {analyte.date}
                  </Typography>
                </Stack>
              </Box>
            ))}
          </Stack>
        </Box>
      </Stack>
    );
  }
);
